import { Controller } from "@hotwired/stimulus"
import { jquery } from 'utils/jquery'

export default class extends Controller {
  static targets = [ "identifier" ]

  connect() {
    const $ = jquery();
    if (!$) {
      return;
    }

    let identifier = `#${this.identifierTarget.id}`;
    $(identifier).multipleSelect({
      allSelected: true,
      formatAllSelected: () => $(identifier).data('all-options-selector-message'),
      formatSelectAll: () => $(identifier).data('toggle-selector-message'),
      filter: $(identifier).data('keyword-filter'),
      maxHeight: '400',
      // Browser-QA bugfix (importation-overview follow-up) — see the near-identical
      // filters/base_component/base_component_controller.js#connect for the full rationale:
      // multiple-select's own change signal (`this.$el.trigger('change')`,
      // vendor/assets/javascripts/multiple-select.js:533-536) is jQuery-only and never reaches a
      // Stimulus `data-action="change->..."` listener. Dispatch a real, bubbling native `change`
      // from every selection-changing callback instead.
      onClick: () => this.dispatchNativeChange(),
      onCheckAll: () => this.dispatchNativeChange(),
      onUncheckAll: () => this.dispatchNativeChange()
    });
  }

  dispatchNativeChange() {
    this.identifierTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
